import { render, staticRenderFns } from "./SidebarFileList.vue?vue&type=template&id=1f0192f7"
import script from "./SidebarFileList.vue?vue&type=script&lang=ts"
export * from "./SidebarFileList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0192f7')) {
      api.createRecord('1f0192f7', component.options)
    } else {
      api.reload('1f0192f7', component.options)
    }
    module.hot.accept("./SidebarFileList.vue?vue&type=template&id=1f0192f7", function () {
      api.rerender('1f0192f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/sidebaritems/SidebarFileList.vue"
export default component.exports